import get from '@postinumero/map-get-with-default';
const listeners = new Map();
export default (key) => get(listeners, key, () => new Map());
//# sourceMappingURL=listeners.js.map